import { render, staticRenderFns } from "./orderHome.vue?vue&type=template&id=55d67991&scoped=true&"
import script from "./orderHome.vue?vue&type=script&lang=js&"
export * from "./orderHome.vue?vue&type=script&lang=js&"
import style0 from "./orderHome.vue?vue&type=style&index=0&id=55d67991&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d67991",
  null
  
)

export default component.exports